import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { RoleModuleState } from "models/roleModule";

const initialState: RoleModuleState = {
  loading: false,
  data: {},
  addModuleMessage: "",
  message: "",
  success: false,
  updateMessage: "",
  addModuleLoading: false,
  updateModuleMessage: "",
  updateModuleLoading: false,
  deleteLoading: false,
  deleteMessage: "",
  allModuleList: [],
  allModuleListMessage: "",
  allModuleListLoading: false,
};

const roleModuleSlice = createSlice({
  name: "roleModule",
  initialState,
  reducers: {
    getModules(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getModulesSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getModulesFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addModules(state, action: PayloadAction<ApiResponse>) {
      state.addModuleLoading = true;
      state.addModuleMessage = "";
    },
    addModulesSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addModuleLoading = false;
      state.addModuleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addModulesFailed(state, action: PayloadAction<ApiResponse>) {
      state.addModuleLoading = false;
      state.addModuleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateModule(state, action: PayloadAction<ApiResponse>) {
      state.updateModuleLoading = true;
      state.updateModuleMessage = "";
    },
    updateModuleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateModuleLoading = false;
      state.updateModuleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateModuleFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateModuleLoading = false;
      state.updateModuleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteModule(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteModuleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteModuleFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    getAllModuleList(state, action: PayloadAction<ApiResponse>) {
      state.allModuleListLoading = true;
      state.allModuleListMessage = action.payload.message;
    },
    getAllModuleListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.allModuleListLoading = false;
      state.allModuleList = action.payload.roleModuleData;
    },
    getAllModuleListFailed(state, action: PayloadAction<ApiResponse>) {
      state.allModuleListLoading = false;
      state.allModuleListMessage = "";
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.addModuleLoading = false;
      state.addModuleMessage = "";
      state.updateMessage = "";
      state.deleteMessage = "";
      state.updateModuleMessage = "";
      state.updateModuleLoading = false;
      state.deleteMessage = "";
      state.deleteLoading = false;
    },
  },
});

//Actions
export const roleModuleActions = roleModuleSlice.actions;

//Selectors
export const getModulesData = (state: RootState) => state.roleModule.data;
export const getModulesDataLoad = (state: RootState) =>
  state.roleModule.loading;
export const addModuleIsLoading = (state: RootState) =>
  state.roleModule.addModuleLoading;
export const addModuleIsMessage = (state: RootState) =>
  state.roleModule.addModuleMessage;
export const updateModuleMessage = (state: RootState) =>
  state.roleModule.updateModuleMessage;
export const updateModuleLoading = (state: RootState) =>
  state.roleModule.updateModuleLoading;
export const deleteModuleLoad = (state: RootState) =>
  state.roleModule.deleteLoading;
export const deleteModuleMsg = (state: RootState) =>
  state.roleModule.deleteMessage;
export const getAllModuleData = (state: RootState) =>
  state.roleModule.allModuleList;

//Reducers
const roleModuleReducer = roleModuleSlice.reducer;
export default roleModuleReducer;
